/** Loading, old copies and no connection, on every page (`PageStates.tsx`, `ConnectionNotice`). */
export const ca_offline = {
  connection: {
    offline: 'El dispositiu no té connexió',
    unreachable: 'Sense connexió amb la plataforma',
    stored: 'La connexió ha tornat',
    /** The connection came back and nothing on the page is a stored copy. */
    backHint: 'Ja es torna a desar i enviar tot.',
    /** When what the page shows was known, as an hour of today or a day and an hour. */
    since: (when: string) => `El que veus és de ${when}.`,
    sinceUnknown: 'El que veus pot no estar al dia.',
    storedHint: (when: string) =>
      `Part del que veus és la còpia de ${when}. Actualitza per veure-ho al dia.`,
    /** Writes are never kept to send later (roadmap item app-installable). */
    noWrites: 'Sense connexió no es desa ni s’envia res: torna-ho a fer quan tornis a tenir-ne.',
    retry: 'Torna-ho a provar',
    /** A list a step needs that did not arrive for want of a connection (`LoadProblemNote`). */
    offlineWhat: (what: string) =>
      `Sense connexió: no s’han pogut llegir ${what}, i aquest dispositiu no en té cap còpia.`,
    refresh: 'Actualitza',
    /** No connection and nobody signed in: sign-out forgets every copy (web card 227). */
    signedOut:
      'Has sortit del compte i aquest dispositiu no té cap còpia de les teves dades: en sortir s’esborren. Torna a entrar quan tinguis connexió.',
    signedOutNever:
      'Sense el compte obert, aquest dispositiu no té cap còpia de les teves dades: entra-hi quan tinguis connexió.',
    at: (hm: string) => `les ${hm}`,
    atDay: (day: string, hm: string) => `${day} a les ${hm}`,
  },
  page: {
    loading: 'Carregant…',
    /** A page whose first read did not arrive, with nothing stored to show instead. */
    offlineNothing:
      'Sense connexió, i aquest dispositiu no en té cap còpia: obre-la un cop amb connexió i després es podrà veure sense.',
    failed: 'No s’ha pogut carregar. Torna-ho a provar d’aquí a una estona.',
    retry: 'Torna-ho a provar',
  },
  /** Installing the app (roadmap item app-installable, `InstallOffer`). */
  installApp: {
    button: 'Instal·la l’aplicació',
    /** Safari on an iPhone or an iPad has no install button: its share sheet does it (web card 225). */
    ios: 'Per instal·lar-la al mòbil:',
    iosSteps: 'Comparteix → Afegeix a la pantalla d’inici',
  },
};
